import React from 'react';
import type { NextPage } from 'next';
import { CmsThemes, type TLocale } from 'src/lib/constants';
import type { Entry } from 'src/types/contentful-sdk-compat';
import { BlogOverviewTemplate } from 'src/templates/BlogOverviewTemplate';

type Fields = {
  heading: string;
  metaDescription: string;
  metaTitle: string;
};

type IndexProps = {
  fields: Fields;
  posts?: Entry<{ fields?: Record<string, unknown> }>[];
  pageCount?: number;
  allTags?: string[];
  locale?: TLocale;
};

const BlogIndexPage: NextPage<IndexProps> = ({
  fields,
  posts,
  pageCount,
  allTags,
  locale,
}) => {
  return (
    <BlogOverviewTemplate
      fields={fields}
      posts={posts}
      heading={fields.heading}
      pageNum={1}
      totalPages={pageCount}
      basePath='/blog'
      allTags={allTags}
      cmsTheme={CmsThemes.WEB3}
      locale={locale}
    />
  );
};

export default BlogIndexPage;
